export enum TRANSFORMATION_STATUS {
	notYetApplied = 'not_yet_applied',
	transformed = 'transformed',
	transformedFfmpeg = 'transformed_ffmpeg',
	notApplicable = 'not_applicable',
	failed = 'failed',
}

export type TStorageProvider = 'r2'

export type TMediaResource = {
	publicId: string
	key?: string
	resourceType: string
	format: string
	bytes: number
	storageProvider?: string
	hasAutoTransformation?: TRANSFORMATION_STATUS
	bucketRootUrl?: string
}

export type TR2FileData = {
	key: string
	url: string
	contentType: string
	bytes: number
	format: string
	storageProvider: TStorageProvider
	bucketRootUrl: string
}

export type TR2FileUploadResult = TMediaResource &
	Omit<TR2FileData, 'contentType'>

export type TUploadedMedia = Omit<TR2FileUploadResult, 'url'>

export type TR2PresignedUrl = {
	id: string
	uploadPreset: string
	presignedUrl: string
	key: string
}
